import { render, staticRenderFns } from "./approved-routine.vue?vue&type=template&id=039d9bec"
import script from "./approved-routine.vue?vue&type=script&lang=js"
export * from "./approved-routine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports